export const MOTION_GRID_WIDTH = 10;
export const MOTION_GRID_HEIGHT = 10;
export const MOTION_GRID_LENGTH = MOTION_GRID_WIDTH * MOTION_GRID_HEIGHT;

/**
 * Convert a base64 encoded ROI region into an array of numbers between 0 and 3.
 */
export function decodeMotionGrid(motionString: string | undefined): number[] | undefined {
  if (!motionString) {
    return undefined;
  }

  const grid: number[] = new Array(MOTION_GRID_LENGTH);

  try {
    const buf = atob(motionString);
    if (buf.charCodeAt(0) !== 1) {
      console.error('invalid encoded motion string: ' + motionString);
      return undefined;
    }

    for (let i = 0; i < 25; i++) {
      grid[4 * i] = (buf.charCodeAt(i + 1) >> 6) & 0x03;
      grid[4 * i + 1] = (buf.charCodeAt(i + 1) >> 4) & 0x03;
      grid[4 * i + 2] = (buf.charCodeAt(i + 1) >> 2) & 0x03;
      grid[4 * i + 3] = buf.charCodeAt(i + 1) & 0x03;
    }

    return grid;
  } catch (err) {
    console.error('error while decoding motion string: ' + err);
    return undefined;
  }
}

export function encodeROI(roiSelection: readonly boolean[]): string {
  const roiBuffer: number[] = [];

  roiBuffer.push(0x01);

  for (let i = 0; i < MOTION_GRID_LENGTH / 4; i++) {
    let b = 0x00;

    for (let k = 0; k < 4; k++) {
      const v = roiSelection[4 * i + k] ? 0x01 : 0x00;
      b = b | (v << (2 * (3 - k)));
    }

    roiBuffer.push(b);
  }

  const base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(roiBuffer) as any));

  return base64String;
}
